export const validateArrayOfObjects = (
  array,
  validationConfig,
  errorMessages
) => {
  let errors = [];

  for (let i = 0; i < array.length; i++) {
    let object = array[i];
    for (let prop in object) {
      let validation = validationConfig[prop];
      if (!validation) continue;
      if (object[prop] === null && !validation.enabledCondition) continue;
      if (validation.enabledCondition) {
        if (!!object.enabled && validation.required && !object[prop]) {
          errors.push({
            index: i,
            property: prop,
            message: errorMessages[validation.requiredKeyMessage],
          });
        }
        continue;
      }
      if (validation.required && !object[prop]) {
        errors.push({
          index: i,
          property: prop,
          message: errorMessages[validation.requiredKeyMessage],
        });
        continue;
      }

      if (typeof object[prop] === 'string' && validation.min) {
        if (object[prop].length < validation.min) {
          errors.push({
            index: i,
            property: prop,
            message: `${errorMessages.minLength} ${validation.min}`,
          });
        }
      }

      if (typeof object[prop] === 'string' && validation.max) {
        if (object[prop].length > validation.max) {
          errors.push({
            index: i,
            property: prop,
            message: `${errorMessages.maxLength} ${validation.max}`,
          });
        }
      }

      if (typeof object[prop] === 'number' && validation.min) {
        if (+object[prop] < validation.min) {
          errors.push({
            index: i,
            property: prop,
            message: `${errorMessages.minValue} ${validation.min}`,
          });
        }
      }

      if (typeof object[prop] === 'number' && validation.max) {
        if (+object[prop] > validation.max) {
          errors.push({
            index: i,
            property: prop,
            message: `${errorMessages.maxValue} ${validation.max}`,
          });
        }
      }
    }
  }

  return errors;
};

export const validationConfigFilters = {
  label: {
    required: true,
    requiredKeyMessage: 'requiredName',
    min: 1,
    max: 50,
  },
  maxLength: {
    required: true,
    requiredKeyMessage: 'requiredLength',
    min: 1,
    max: 1000,
  },
  orderNum: {
    required: true,
    requiredKeyMessage: 'requiredOrderNum',
    enabledCondition: true,
  },
};

export const validationConfigTables = {
  label: {
    required: true,
    requiredKeyMessage: 'requiredName',
    min: 1,
    max: 50,
  },
  width: {
    required: true,
    requiredKeyMessage: 'requiredWidth',
    min: 100,
    max: 1000,
  },
  orderNum: {
    required: true,
    requiredKeyMessage: 'requiredOrderNum',
    enabledCondition: true,
  },
};

export const types = {
  ACTION: 'action',
  TEXT: 'TEXT',
};

export const AdministrationForms = {
  TABLE: 'TABLE',
  FILTERS: 'FILTERS',
  ACTIONS: 'ACTIONS',
  META_DATA_FILTERS: 'META_DATA_FILTERS',
};

export const ActionTypes = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  ACTIVATE: 'ACTIVATE',
  DEACTIVATE: 'DEACTIVATE',
  ACTIVATE2FA: 'ACTIVATE2FA',
  DEACTIVATE2FA: 'DEACTIVATE2FA',
  PASSWORD_CHANGE: 'PASSWORD_CHANGE',
  PREVIEW: 'PREVIEW',
  VERIFY: 'VERIFY',
  REJECT: 'REJECT',
  META_DATA_PREVIEW: 'META_DATA_PREVIEW',
  CONSENT_GIVE: 'CONSENT_GIVE',
  APPROVE: 'APPROVE',
  DENY: 'DENY',
  PROCESS: 'PROCESS',
  PROCESS1: 'PROCESS1',
  PROCESS2: 'PROCESS2',
  SHOW_CHILDREN: 'SHOW_CHILDREN',
};

export function getOrderNumbers(item, allItems, orderNumbers) {
  const settingsOrNums =
    allItems
      ?.filter((s) => s.id !== item.id && s.orderNum !== 0)
      ?.map((s) => s.orderNum) || [];

  return (
    orderNumbers
      ?.filter((o) => !settingsOrNums?.includes(o.orderNum))
      ?.map((o) => o.orderNum) || []
  );
}

export function metaDataFilter(item) {
  return item.field.startsWith('MP_');
}

export const containsMetaDataFilters = (list) => {
  return list.some((item) => item.field && metaDataFilter(item));
};

export function filterSettingsPayload(settings, reference, formType) {
  return settings.filter((item) =>
    reference === formType.META_DATA_FILTERS
      ? metaDataFilter(item)
      : !metaDataFilter(item)
  );
}

export const numberOfBasicFilters = (settings) => {
  return settings.filter((item) => !metaDataFilter(item)).length;
};

export const numberOfMetaDataFilters = (settings) => {
  return settings.filter((item) => metaDataFilter(item)).length;
};

//TODO dopuniti sa proširenjem akcija
export const getOperationIcons = (operation) => {
  switch (operation) {
    case ActionTypes.CREATE:
      return [
        'fa-plus',
        'fa-folder-plus',
        'fa-user-plus',
        'fa-circle-plus',
        'fa-square-plus',
        'fa-person-circle-plus',
        'fa-file-circle-plus',
      ];
    case ActionTypes.UPDATE:
      return ['fa-edit', 'fa-pen', 'fa-user-pen', 'fa-file-pen'];
    case ActionTypes.DELETE:
      return ['fa-trash-can', 'fa-trash', 'fa-user-xmark', 'fa-eraser'];
    case ActionTypes.ACTIVATE:
      return ['fa-play-circle', 'fa-play', 'fa-file-circle-check'];
    case ActionTypes.DEACTIVATE:
      return ['fa-times-circle', 'fa-stop', 'fa-file-circle-xmark'];
    case ActionTypes.ACTIVATE2FA:
      return ['fas fa-qrcode', 'fa-play-circle'];
    case ActionTypes.DEACTIVATE2FA:
      return ['fa-times-circle', 'fa-stop', 'fa-solid fa-ban'];
    case ActionTypes.PREVIEW:
      return ['fa-magnifying-glass', 'fa-eye'];
    case ActionTypes.VERIFY:
      return ['fa-check', 'fa-check-square-o', 'check-circle-o'];
    case ActionTypes.CONSENT_GIVE:
      return ['fa-check', 'fa-check-square-o', 'check-circle-o'];
    case ActionTypes.META_DATA_PREVIEW:
      return ['fa-table', 'fa-eye'];
    case ActionTypes.PROCESS:
    case ActionTypes.PROCESS1:
    case ActionTypes.PROCESS2:
      return [
        'fa fa-tasks',
        'fa-file-signature',
        'fas fa-percent',
        'fa-solid fa-calculator',
      ];
    case ActionTypes.SHOW_CHILDREN:
      return ['fa-solid fa-folder-tree', 'fas fa-bars fa'];
    case ActionTypes.PASSWORD_CHANGE:
      return ['fas fa-lock fa-2x', 'fas fa-unlock-alt'];
    default:
      return ['fa-coffee'];
  }
};
